<template>
  <div class="rights-box">
    <div class="rights-list">
      <div class="rights-item rights-1" v-for="(item, index) in imgList" :key="index">
        <img class="img" :src="item.imgUrl"/>
        <div class="rights-btn" @click="handleJoin">
          <img class="img" :src="item.btnUrl"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'

export default {
  data () {
    return {
      imgList: [
        {
          imgUrl: 'https://oss.aqdpay.com/appweb/qdtRights/rights11.png',
          btnUrl: 'https://oss.aqdpay.com/appweb/qdtRights/rightsbtn11.png'
        },
        {
          imgUrl: 'https://oss.aqdpay.com/appweb/qdtRights/rights12.png',
          btnUrl: 'https://oss.aqdpay.com/appweb/qdtRights/rightsbtn12.png'
        },
        {
          imgUrl: 'https://oss.aqdpay.com/appweb/qdtRights/rights21.png',
          btnUrl: 'https://oss.aqdpay.com/appweb/qdtRights/rightsbtn21.png'
        },
        {
          imgUrl: 'https://oss.aqdpay.com/appweb/qdtRights/rights22.png',
          btnUrl: 'https://oss.aqdpay.com/appweb/qdtRights/rightsbtn22.png'
        }
      ]
    }
  },
  methods: {
    handleJoin () {
      if (window._czc) {
        window._czc.push(['_trackEvent', '权益包立即开通', '权益包立即开通', '权益包立即开通', '权益包立即开通', '005'])
      }
      let ua = navigator.userAgent.toLowerCase()
      let isWeixin = ua.indexOf('micromessenger') !== -1
      if (isWeixin) {
        Toast({
          message: '请在右上角选择在浏览器打开'
        })
        return
      }
      window.location.href = 'bjqd://'
      setTimeout(function () {
        window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.bsit.coband'
      }, 1200)
    }
  }
}
</script>
<style lang='scss' scoped>
.rights-box {
  background: url('https://oss.aqdpay.com/appweb/qdtRights/rightsbg.png') no-repeat left top;
  background-size: 100%;
  padding-top: 250px;
  padding-bottom: 30px;
}
.rights-bg {
  .img {
    width: 100%;
  }
}
.rights-list {
  padding: 15px 15px 15px 15px;
}
.rights-item {
  position: relative;
  margin-bottom: 15px;
  .img {
    width: 100%;
  }
}
.rights-btn {
  position: absolute;
  bottom: 7px;
  margin: 5px 20px;
  .img {
    width: 100%;
  }
}
</style>
